import { ResultsModuleRequests } from "./ResultsModule.requests";
import { ApiSchema } from "@api-types";
import { Globals } from "types/globals";

export namespace ResultsModuleTypes {
  export type SplitMode = "market" | "demographic" | "adhoc" | "segment" | "panelType" | null;
  export type SplitView = "skewed" | "stacked" | "stacked-weighted" | null;
  export type SplitBy = { view: SplitView; mode: SplitMode; ids: number[] | null };
  export type MetricVisualization = "top2combined" | "top2split" | "fullscale";
  export type BenchmarkType = "top2" | "top1";

  export type LaunchTestBenchmarkDelta = {
    benchmarkPercentage?: number;
    delta?: number;
    isStatisticallySignificant: boolean;
  };

  export const ProductLaunchMetrics = [
    Globals.StandardQuestions.NPDAware,
    Globals.StandardQuestions.InstoreVisibility,
    Globals.StandardQuestions.NPDTried,
  ];

  export const TrialistMetrics = [Globals.StandardQuestions.Experience, Globals.StandardQuestions.Repeat];

  export const LaunchTestFunnelMetrics = [...ProductLaunchMetrics, ...TrialistMetrics];

  export const sortOrder = [
    Globals.StandardQuestions.Desire,
    Globals.StandardQuestions.Likeability,
    Globals.StandardQuestions.Distinctiveness,
    Globals.StandardQuestions.Believability,
    Globals.StandardQuestions.Consideration,
    Globals.StandardQuestions.PurchaseIntent,
    Globals.StandardQuestions.PurchaseIntentV2,
    Globals.StandardQuestions.BrandFit,
    Globals.StandardQuestions.BrandRecognition,
  ];

  export type State = {
    selectedMetricQuestionsIds?: number[] | null;
    selectedQuestionFilterKey?: number | null;
    benchmarkTypeSelection: ResultsModuleTypes.BenchmarkTypeSelection;
    segments?: ResultsModuleRequests.Segment[];
    project?: ResultsModuleRequests.Project;
    metricVisualization: MetricVisualization;
    benchmarkType: BenchmarkType;
    benchmarkMode: "percentage" | "index";
    schedulingState?: ApiSchema.SchedulingState;
    schedulingPanelOption: "completed" | "upcoming";
    activeSummaryType: ApiSchema.AiSummaryTypes | null;
    maxSelectedMetrics?: number;

    exportSidepanelVisible?: boolean;
    testInfoSidepanelVisible?: boolean;
    creditCostSidepanelVisible?: boolean;
    benchmarkSidepanelVisible?: boolean;
    followersSidePanelVisible?: boolean;
    exportPlanSidePanelVisible?: boolean;
    segmentSidepanel?: {
      id?: number;
      filters: ApiSchema.SegmentResponsesFilters;
    };
    schedulingPanelVisible?: boolean;
    schedulingPanelEditing?: boolean;
    schedulingEditPanelVisible?: boolean;
    narrativeReturn?: {
      narrativeId: number;
      exportId?: number | null;
      slideNumber?: number | null;
      scrollY: number;
      expandedSectionIds: number[];
      destinationPathname: string;
    } | null;
    narrativeVersionExportsRefreshAt?: Date;
    narrativeSectionsRefreshAt?: Date;
    narrativesRefreshAt?: Date;
    creatingReport?: boolean;
    pulseReportTabAt?: Date;
  };

  export type QueryState = {
    segmentId: number;
    selectedRegionId: number;
    selectedFilterIds: { [key in string]: number[] };
    selectedTestOptionIds: number[];
    selectedDates: [Date | null, Date | null];
    selectedQuestionOptionFilterIds: { [key in number]: { [key in number]: boolean } };
    withObjective: boolean;
    selectedPanelType: ApiSchema.PanelType;
    selectedSurveyRunIds: number[];
    selectedProjectGroupSegmentIds: number[];
    selectedAdQuestionIds: number[];
    selectedCompareSections: string[];
    splitBy: SplitBy;
  };

  export type CompareSection = { key: string; label: string };

  export type CompareTab = "concepts" | "audiences";

  export type ThemeBubbles = {
    projectId: number;
    textResponses: { standardQuestionId: number; testOptionId: number };
    theme: { id: number; themeLabel: string; shortLabel: string | undefined };
    count: number;
    sentiment?: "neutral" | "positive" | "negative";
  };

  export type Week = {
    date: Date;
    scheduleDateKey: string;
    ids: number[];
    week: number;
  };

  export type SegmentFeObj = {
    selectedTestOptionIds: number[] | null;
    selectedDates: (string | null | undefined)[] | undefined;
    selectedPanelType: ApiSchema.PanelType | undefined;
    selectedRegionId: number | undefined;
    selectedFilterIds:
      | {
          [x: string]: number[];
        }
      | undefined;
    selectedQuestionOptionFilterIds:
      | {
          [x: number]: {
            [x: number]: boolean;
          };
        }
      | undefined;
    selectedSurveyRunIds: number[] | undefined;
    selectedProjectGroupSegmentIds: number[] | undefined;
  };
  export type BenchmarkTypeSelection = { type: "testAverage" | "benchmark" | "testOption"; id?: number };
  export type BenchmarkTypeInfo = {
    label: string;
    isAvailable: boolean;
    projectCount: number;
    regionCode?: string;
    projectType?: ApiSchema.ProjectTypeLookup;
  };
}
